import { j as c } from "../../_virtual/jsx-runtime.js";
import { c as m } from "../../_virtual/compiler-runtime.js";
import { cn as n } from "../../utils/cn.js";
const p = (a) => {
  const e = m.c(10);
  let l, t;
  e[0] !== a ? ({
    className: l,
    ...t
  } = a, e[0] = a, e[1] = l, e[2] = t) : (l = e[1], t = e[2]);
  let s;
  e[3] !== l ? (s = n("inline-block", l), e[3] = l, e[4] = s) : s = e[4];
  let o, r;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ c.jsx("path", { d: "M15 5V3C15 2.45 14.55 2 14 2H13V0.75C13 0.34 12.66 0 12.25 0C11.84 0 11.5 0.34 11.5 0.75V2H4.5V0.75C4.5 0.34 4.16 0 3.75 0C3.34 0 3 0.34 3 0.75V2H2C1.45 2 1 2.45 1 3V5H15Z" }), r = /* @__PURE__ */ c.jsx("path", { d: "M1 6.5V13C1 13.55 1.45 14 2 14H14C14.55 14 15 13.55 15 13V6.5H1Z" }), e[5] = o, e[6] = r) : (o = e[5], r = e[6]);
  let i;
  return e[7] !== t || e[8] !== s ? (i = /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", fill: "currentColor", role: "img", focusable: "false", className: s, ...t, children: [
    o,
    r
  ] }), e[7] = t, e[8] = s, e[9] = i) : i = e[9], i;
};
p.displayName = "CalendarIcon";
export {
  p as CalendarIcon
};
